<template>
  <div>
    <fieldset class="border p-2">
      <legend>
        <small style="font-size:15px; font-weight: bold">update transporter</small>
      </legend>
      <div>
        <form @submit.prevent="transporterUpdate()">
          <div class="row">
            <div class="col-md-6">
              <input type="hidden" class="id" :value="Transporter.id" />
              <div class="form-group">
                <label>Registration date</label>
                <input
                  type="date"
                  class="form-control reg_date input-rounded f-s-14"
                  :value="Transporter.reg_date"
                  placeholder="registration date"
                  readonly
                  required
                />
              </div>
              <div class="form-group">
                <label>Email address</label>
                <input
                  type="email"
                  class="form-control email_address input-rounded f-s-14"
                  :value="Transporter.email_address"
                  placeholder="email address"
                  required
                />
              </div>
              <div class="form-group">
                <label>Contact person</label>
                <input
                  type="text"
                  class="form-control contact_person input-rounded f-s-14"
                  :value="Transporter.contact_person"
                  placeholder="contact person"
                  required
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Transporter name</label>
                <input
                  type="text"
                  class="form-control transporter_name input-rounded f-s-14"
                  :value="Transporter.transporter_name"
                  placeholder="transporter name"
                  required
                />
              </div>
              <div class="form-group">
                <label>Mobile number</label>
                <input
                  type="number"
                  class="form-control mobile_number input-rounded f-s-14"
                  :value="Transporter.mobile_number"
                  placeholder="mobile number"
                  required
                />
              </div>
              <div class="form-group">
                <label>Pin no</label>
                <input
                  type="text"
                  class="form-control pin_no input-rounded f-s-14"
                  :value="Transporter.pin_no"
                  placeholder="kra pin number"
                  required
                />
              </div>
            </div>
          </div>
          <button type="submit" class="btn btn-primary btn-flat updatingTransporter btn-rounded">
            <i class="fa fa-refresh"></i> update transporter
          </button>
          <button type="button" class="btn btn-info btn-flat updatingTransporterLoader btn-rounded">
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            <i class="fa fa-spinner fa-spin" style="font-size:24px"></i> please wait...
          </button>
        </form>
      </div>
    </fieldset>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import router from "../router/index";
export default {
  created() {
    if (this.$store.getters.Transporter.length === 0) {
      router.push('/managetransporters');
    }
  },
  computed: {
    ...mapGetters(["Transporter"])
  },
  methods: {
    ...mapActions(["transporterUpdate"])
  }
};
</script>
<style scoped>
.updatingTransporterLoader {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/transporters/updatetransporter.vue